import { render } from "./LogoTitle.vue?vue&type=template&id=0a9cd7bc&scoped=true"
import script from "./LogoTitle.vue?vue&type=script&lang=js"
export * from "./LogoTitle.vue?vue&type=script&lang=js"

import "./LogoTitle.vue?vue&type=style&index=0&id=0a9cd7bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9cd7bc"]])

export default __exports__